import React from 'react';
import { Content } from '../../components/light/Content';

export class NotFoundScreen extends React.Component {

  // componentDidMount(){
  //   document.getElementById('DesktopMenu')!.className ="menu-w color-scheme-dark color-style-bright menu-position-side menu-side-left menu-layout-mini sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link"
  // }

  // componentWillUnmount(){
  //   document.getElementById('DesktopMenu')!.className ="min-full-height menu-w selected-menu-color-light menu-activated-on-hover menu-has-selected-link color-scheme-dark color-style-bright sub-menu-color-bright menu-position-side menu-side-left menu-layout-compact sub-menu-style-over"
  // }

  render() {
    return (
      <Content>
        <div className="big-error-w">
          <h1>404</h1>
          <h5>Page not Found</h5>
          <h4>Oops, Something went missing...</h4>
        </div>
      </Content>
    )
  }
}